<template>
  <v-main>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mb-4">{{$t("Register weight")}}</h1>
          <div>
            <v-flex xs12 class="mb-4">
              <v-layout row wrap>
                <v-flex shrink><v-select class="ml-2" hide-details="true" :items="VT25List" v-model="selectedVT25" @change="saveVT25(selectedVT25)" :label="$t('Weight Indicator')"></v-select></v-flex>
                <v-flex grow></v-flex>
                <v-layout row wrap class="textsize-svs" style="padding: 5px 8px 4px 8px" >
                </v-layout>
              </v-layout>
            </v-flex>
            <v-card raised  class="mb-4">
            </v-card>
            <v-card raised>
              <v-layout row wrap>
                <v-flex xs12 md6>
                    <v-layout v-if="!isHide('Agreement')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Agreement")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{item.AgreementNo}} - {{item.AgreementName}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{item.CustomerNo}} - {{item.CustomerName}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('Plant')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Plant")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{item.PlantNo}} - {{item.PlantName}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('Carrier')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Carrier")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{item.CarrierNo}} - {{item.CarrierName}}</v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                    <v-layout v-if="!isHide('Batches registered')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                      <v-flex class="font-weight-bold" d-flex xs4>{{$t("Batches registered")}}:</v-flex>
                      <v-flex class="font-weight-bold" d-flex xs8>{{item.RegistrationCount}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{item.ArticleNo}} - {{item.ArticleName}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('RequisitionNo1')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RequisitionNo1")}}:</v-flex>
                    <v-flex d-flex xs8>{{item.RequisitionNo}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('Weight')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4>{{$t("Weight")}}:</v-flex>
                      <v-flex d-flex xs8>{{item.TotalAmount}} kg.</v-flex>
                    </v-layout>
                </v-flex>
                </v-layout>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 md12>
                  </v-flex>
                  <v-flex xs12 class ="ml-0">
                    <v-form ref="form" v-model="valid">
                      <v-layout row wrap>
                        <v-flex d-flex xs12 sm9 class="textsize-large thin-border ml-1" style="min-height:60px; align-items:center; justify-content:center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                            <div class="text-center">
                              {{displayWeight}} kg
                            </div>
                          </v-flex>
                        <v-layout row wrap class="textsize-svs" style="padding: 10px 8px 4px 8px" >
                        </v-layout>
                        <v-flex grow>
                          <v-btn class="mt-1 mr-3 mb-n1" @click.prevent="saveRegistration" color="success" :loading="submitting" type="primary" :disabled="validate(item)">{{$t('+ Add new batch')}}</v-btn>
                        </v-flex>
                      </v-layout>
                      <v-btn class="ml-0 mt-2 mr-3 mb-2" @click.prevent="exitRegistration" color="primary" >{{$t('Save')}}</v-btn>
                      <v-btn class="ml-3 mt-2 mr-3 mb-2" @click.prevent="preFinish" color="primary">{{$t('Finish')}}</v-btn>
                    </v-form>
                    <v-data-table hide-default-footer dense
                    :headers="translatedHeaders()"
                    :items="batchregistrations"
                    :items-per-page="100"
                    class="elevation-1">
                      <template v-slot:[`item.BatchNo`]="{ item }">
                        <v-flex class="font-weight-bold">
                          {{ item.BatchNo }}
                        </v-flex>
                      </template>
                      <template v-slot:[`item.CreatedDate`]="{ item }">
                        <v-flex class="font-weight-bold">
                          {{ getDate(item.CreatedDate) }}
                        </v-flex>
                      </template>
                      <template v-slot:[`item.kg`]="{ item }">
                        <v-flex class="font-weight-bold">
                          <v-btn
                            @click="preAlterRegDialog(item, 0)"
                          >{{$t('Update Weight')}}</v-btn>
                        </v-flex>
                      </template>
                      <template v-slot:[`item.tare`]="{ item }">
                        <v-flex class="font-weight-bold">
                          <v-btn
                            @click="preAlterRegDialog(item, 1)"
                          >{{$t('Reprint')}}</v-btn>
                        </v-flex>
                      </template>
                      <template v-slot:[`item.count`]="{ item }">
                        <v-flex class="font-weight-bold">
                          <v-btn
                            @click="preAlterRegDialog(item, 2)"
                          >{{$t('Delete')}}</v-btn>
                        </v-flex>
                      </template>
                      <template slot="body.append">
                      </template>
                  </v-data-table>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog
          v-model="areYouSureFinishDialog" max-width="400" persistent>
        <v-card>
          <v-card-title class="headline">{{$t("Finish")}}?</v-card-title>
          <template>
            <v-card-text class="font-weight-bold">{{$t("Do you really want to finish")}} {{$t("Agreement")}} {{item.AgreementNo}}</v-card-text>
          </template>
          <v-card-actions>
            <v-spacer></v-spacer>
              <template>
                <v-btn ref="yesButton" color="success" @click="areYouSureFinishDialog = false; finishRegistration(item)">{{$t("Yes")}}</v-btn>
                <v-btn ref="noButton" color="primary" @click="areYouSureFinishDialog = false" autofocus>{{$t("No")}}</v-btn>
              </template>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog
          v-model="alterExistingDialog" max-width="400" persistent>
      <v-card>
        <v-card-title class="headline">{{existingBatchChangeText}}?</v-card-title>
          <template>
            <v-card-text class="font-weight-bold">{{$t("Do you really want to")+" " + existingBatchChangeText }} {{$t("Batch")}} {{this.BatchNo}} {{existingBatchFollowingChangeText}}</v-card-text>
          </template>
        <v-card-actions>
          <v-spacer></v-spacer>
            <template>
              <v-btn ref="yesButton" color="success" @click="alterExistingDialog = false; postAlterBatchDialog(item)">{{$t("Yes")}}</v-btn>
              <v-btn ref="noButton" color="primary" @click="alterExistingDialog = false" autofocus>{{$t("No")}}</v-btn>
            </template>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
          v-model="areYouSureRegWithLowWeightDialog" max-width="400" persistent>
        <v-card>
          <v-card-title class="headline">{{$t("Below minimum weight")}}</v-card-title>
          <template>
            <v-card-text class="font-weight-bold">{{$t("Do you really want to add weight")}} {{this.displayWeight}} {{$t("as batch nr")}} {{this.batchregistrations.length+1}}</v-card-text>
          </template>
          <v-card-actions>
            <v-spacer></v-spacer>
              <template>
                <v-btn ref="yesButton" color="success" @click="areYouSureRegWithLowWeightDialog = false; dialogSave()">{{$t("Yes")}}</v-btn>
                <v-btn ref="noButton" color="primary" @click="areYouSureRegWithLowWeightDialog = false; dialogCancel()" autofocus>{{$t("No")}}</v-btn>
              </template>
            </v-card-actions>
        </v-card>
    </v-dialog>

    </v-main>

</template>

<script>
import filters from '@/core/mixins/common-filters'
import * as Security from '@/core/security'
import * as BatchRegistration from '@/modules/batch-registration/batch-registration'
import { isNumber } from '@turf/helpers'
import * as LocalStorage from '@/core/local-storage'
import * as DateUtil from '@/core/date'
// import { setTimeout } from '@timers/promises'

export default {
  mixins: [filters],
  name: 'batch-registration-create-registration',
  props: ['id'],
  components: { },
  data: () => ({
    item: {
      Amount: null,
      Comment: null
    },
    form: {
      facilities: [],
      articles: [],
      agreements: [],
      deliveries: [],
      customers: [],
      vehicles: [],
      plants: [],
      carriers: [],
      ScannedData: [],
      facilityNo: '',
      articleNo: '',
      agreementNo: '',
      deliveryNo: '',
      carrierNo: '',
      customerNo: '',
      vehicleNo: '',
      vehicleLicensePlateNo: '',
      requisitionNo1: '',
      requisitionNo2: '',
      comment1: '',
      plantNo: '',
      scannedGroup: [],
      vehicleTare: 0,
      searchCriteria: '',
      top: 100
    },
    batchregistrations: [],
    IndicatorNo: null,
    indicators: null,
    valid: true,
    loading: true,
    submitting: false,
    VT25List: [],
    selectedVT25: null,
    displayWeight: '',
    sortBy: [{ key: 'Batch', order: 'desc' }],
    headers: [
      { text: 'Batch', value: 'BatchNo' },
      { text: 'CreatedDate', value: 'CreatedDate' },
      { text: 'WeightNet', value: 'WeightNet' },
      { text: 'Update weight', value: 'kg' },
      { text: 'Reprint', value: 'tare' },
      { text: 'Delete', value: 'count' }
    ],
    areYouSureFinishDialog: false,
    areYouSureRegWithLowWeightDialog: false,
    alterExistingDialog: false,
    ItemId: '',
    existingBatchChangeText: '',
    existingBatchFollowingChangeText: '',
    existingBatchCahngeState: 0,
    DateCreated: null,
    BatchNo: 0,
    Wieght: 0,
    RegDelay: 0,
    loadBatchesIntervalId: null,
    minChanged: true,
    stable: false,
    minWeightWarning: 0
  }),
  computed: {
    User () {
      return Security.user.token.User
    }
  },
  methods: {
    async cancelBatchRegistrations (batchReg) {
      const res = await BatchRegistration.DelteRegistration(batchReg)
      if (!res.failed) {
        const bres = await BatchRegistration.loadAllBatchOrders(this.$route.params.id)
        if (!bres.failed) {
          this.batchregistrations = bres.data
          this.$forceUpdate()
        }
        const resAgree = await BatchRegistration.loadBatchOrder(this.$route.params.id)
        if (!resAgree.failed) {
          this.item = resAgree.data
        }
      }
    },
    async updateBatchRegistration (batchReg) {
      if (this.item.WeightNet < 1) {
        this.$root.$message.showError(this.$t('Invalid weight. Please fix and retry'))
        return
      }
      if (this.RegDelay !== 0) {
        this.$root.$message.showError(this.$t('Registration cooldown please wait'))
        return
      }
      batchReg.WeightNet = this.item.WeightNet
      const res = await BatchRegistration.UpdateRegistration(batchReg)
      if (!res.failed) {
        const res2 = await BatchRegistration.loadBatchOrder(this.$route.params.id)
        if (!res2.failed) {
          this.item.TotalAmount = res2.data.TotalAmount
        }
        const bres = await BatchRegistration.loadAllBatchOrders(this.$route.params.id)
        if (!bres.failed) {
          this.batchregistrations = bres.data
          this.$forceUpdate()
          this.$root.$message.showSuccess(this.$t('Weight updated, Reprinting confirmation'))
        }
        this.RegDelay = 6
      } else {
        this.RegDelay = 0
      }
    },
    rePrintBatchRegistration (batchReg) {
      batchReg.BatchNo = this.BatchNo
      batchReg.WeightNet = this.Wieght
      const res = BatchRegistration.RePrintRegistration(batchReg)
      if (!res.failed) {
        this.$root.$message.showSuccess(this.$t('Confirmation printed'))
      }
    },
    preAlterRegDialog (batchReg, state) {
      this.ItemId = batchReg.Id
      this.DateCreated = batchReg.CreatedDate
      this.BatchNo = batchReg.BatchNo
      this.Wieght = batchReg.WeightNet
      switch (state) {
        case 0:
          this.existingBatchChangeText = this.$t('Update weight')
          this.existingBatchFollowingChangeText = ''
          this.existingBatchCahngeState = 0
          break
        case 1:
          this.existingBatchChangeText = this.$t('Reprint')
          this.existingBatchFollowingChangeText = ''
          this.existingBatchCahngeState = 1
          break
        default:
          this.existingBatchChangeText = this.$t('Delete')
          this.existingBatchFollowingChangeText = this.$t('and following batches')
          this.existingBatchCahngeState = 2
      }
      this.alterExistingDialog = true
    },
    async postAlterBatchDialog (batchReg) {
      batchReg.Id = this.ItemId
      batchReg.CreatedDate = this.DateCreated
      switch (this.existingBatchCahngeState) {
        case 0:
          await this.updateBatchRegistration(batchReg)
          break
        case 1:
          this.rePrintBatchRegistration(batchReg)
          break
        case 2:
          this.cancelBatchRegistrations(batchReg)
      }
    },
    getDate (date) {
      return DateUtil.getDateTime(date)
    },
    keyDown (event) {
      if ((event.key === 'Escape' && !this.areYouSureFinishDialog && !this.alterExistingDialog)) {
        this.exitRegistration()
      } else if ((event.key === 'Escape')) {
        this.areYouSureFinishDialog = false
        this.alterExistingDialog = false
      }
      if (event.key === 'ArrowLeft' && (this.areYouSureFinishDialog || this.alterExistingDialog || this.areYouSureRegWithLowWeightDialog)) {
        this.$refs.yesButton.$el.focus()
      }
      if (event.key === 'ArrowRight' && (this.areYouSureFinishDialog || this.alterExistingDialog || this.areYouSureRegWithLowWeightDialog)) {
        this.$refs.noButton.$el.focus()
      }
    },
    async keyPressed (event) {
      // console.log('key', event.key, this.areYouSureFinishDialog, this.alterExistingDialog)
      const positiveWeight = isNumber(this.displayWeight) && this.displayWeight > 0
      if (positiveWeight) {
        if (event.key === 'Enter' && !this.areYouSureFinishDialog && !this.alterExistingDialog && !this.areYouSureRegWithLowWeightDialog) {
          if (this.RegBusy) {
            return
          }
          this.RegBusy = true
          await this.saveRegistration()
          this.RegBusy = false
        } else if (event.key === 'Enter') {
          this.areYouSureFinishDialog = false
          this.alterExistingDialog = false
          this.areYouSureRegWithLowWeightDialog = false
        }
      }
    },
    removeKeyEvents () {
      document.removeEventListener('keypress', this.keyPressed)
      document.removeEventListener('keydown', this.keyDown)
    },
    addKeyEvents () {
      document.addEventListener('keypress', this.keyPressed)
      document.addEventListener('keydown', this.keyDown)
    },
    preFinish () {
      this.areYouSureFinishDialog = true
    },
    isHide (fieldName) {
      return false
    },
    async indicatorChanged () {
      await this.loadBatchRegistrations()
    },
    async delay (sec) {
      // await setTimeout(sec)
      await new Promise(resolve => setTimeout(resolve, sec)) // 3 sec
    },
    async saveRegistration () {
      if (!this.minChanged) {
        this.$root.$message.showError(this.$t('Minimum weight change has not been observed'))
        this.submitting = false
        return
      }
      this.submitting = true
      if (this.$refs.form.validate()) {
        /* if (this.RegDelay !== 0) {
          this.$root.$message.showError(this.$t('Registration cooldown please wait'))
          this.submitting = false
          return
        } */
        // await this.delay(4000)

        // handle dialog
        const weight = this.displayWeight / 1
        // console.log('pip', weight, this.minWeightWarning)
        if (weight < this.minWeightWarning) {
          this.areYouSureRegWithLowWeightDialog = true
          setTimeout(() => {
            this.$refs.noButton.$el.focus()
          })
          return
        }

        await this.saveBatch()
      }
      this.submitting = false
    },
    async dialogSave () {
      this.$root.$message.showSuccess(this.$t('Weighing added, Confirmation printed'))
      await this.saveBatch()
      this.submitting = false
    },
    dialogCancel () {
      // console.log('pipcancel')
      this.$root.$message.showError(this.$t('You have declined weighing, please try again'))
      this.submitting = false
    },
    async saveBatch () {
      // Valider front-end data. Fx om. Ved fejl vis besked og return.
      if (await this.validateFrontEndData(this.item)) {
        if (this.item.WeightNet === 0) {
          this.item.WeightNet = this.displayWeight
        }
        const res = await BatchRegistration.saveRegistration(this.item) // på back-end valider front-end data OG data fra DB.
        if (res.failed) {
          this.submitting = false
          // core error handling will inform of issue
          return
        }
        this.$root.$message.showSuccess(this.$t('Weighing added, Confirmation printed'))
        this.minChanged = false
        this.regWeight = this.displayWeight
        this.RegDelay = 6
        const resAgree = await BatchRegistration.loadBatchOrder(this.$route.params.id)
        if (!resAgree.failed) {
          this.item = resAgree.data
        }
        const bres = await BatchRegistration.loadAllBatchOrders(this.$route.params.id)
        if (!bres.failed) {
          this.batchregistrations = bres.data
          this.$forceUpdate()
        }
      } else {
        this.submitting = false
      }
    },
    async finishRegistration (recentReg) {
      this.loading = true
      const res = BatchRegistration.FinishRegistration(recentReg.AgreementId)
      if (!res.failed) {
        this.registrations = res.data
        this.$root.$emit('msgloadBachRegistrations')
        this.exitRegistration()
      }

      this.loading = false
    },
    exitRegistration () {
      // this.stopWeightTimer()
      this.$router.push({ name: 'batch-registration' })
    },
    translatedHeaders () {
      return this.headers.map(header => {
        const h = { ...header }
        h.text = this.$t(header.text)
        return h
      })
    },
    saveVT25 () {
      this.activeVT25 = this.selectedVT25
      LocalStorage.save('activeBatchIndicator', this.activeVT25)
    },
    validate (item) {
      const positiveWeight = isNumber(item.WeightNet) && item.WeightNet > 0
      return !positiveWeight
    },
    stopWeightTimer () {
      if (this.getLiveWeightTimer) {
        this.checkkingIsAlive = false
        this.activeVT25 = false
        clearInterval(this.getLiveWeightTimer)
      }
      if (this.getRegTimer) clearInterval(this.getRegTimer)
    },
    async validateFrontEndData (item) {
      /* if (!item.ArticleNo) {
        this.$root.$message.showError(this.$t('Article is missing. Please fix and retry'))
        return false
      }
      if (!item.CustomerNo) {
        this.$root.$message.showError(this.$t('Customer is missing. Please fix and retry'))
        return false
      } */
      if (!item.VehicleLicensePlateNo) {
        this.$root.$message.showError(this.$t('User licenseplate number is missing. Please fix and retry'))
        return false
      }
      if (this.displayWeight === '0') {
        this.$root.$message.showError(this.$t('Not possible to add 0kg'))
        return false
      }
      // console.log('pip stable', this.stable)
      if (!this.stable) {
        this.$root.$message.showError(this.$t('Waiting for stable weight'))
        await this.delay(2000)
        if (!this.stable) {
          await this.delay(2000)
          if (!this.stable) {
            await this.delay(2000)
            if (!this.stable) {
              this.$root.$message.showError(this.$t('Unstable Weight'))
              return false
            }
          }
        }
      }
      return true
    }
  },
  beforeDestroy () {
    // Unsubscribe to event listener for events for keyboard
    this.removeKeyEvents()
    // Stop live poll VT25/WK60 getWeight
    this.stopWeightTimer()
    clearInterval(this.loadBatchesIntervalId)
  },
  async mounted () {
    // we should not be on this page with unitialised data
    if (this.$route.params.id === undefined) {
      this.$router.push({ name: 'batch-registration' })
    }
    var noValue = Security.user.corporationDetails.find(d => d.Name === 'BatchRegistration_MinWeightWarning')?.Data1 === undefined ?? false
    if (noValue) {
      this.minWeightWarning = 0
    } else {
      this.minWeightWarning = Security.user.corporationDetails.find(d => d.Name === 'BatchRegistration_MinWeightWarning')?.Data1
    }
    if (this.$route.params.id) {
      const res = await BatchRegistration.loadBatchOrder(this.$route.params.id)
      if (!res.failed) {
        this.item = res.data
        const bres = await BatchRegistration.loadAllBatchOrders(this.$route.params.id)
        if (!bres.failed) {
          this.batchregistrations = bres.data
        }
      }
    }
    this.addKeyEvents()
    // Load current (stored) VT25 id
    const vt25 = LocalStorage.load('activeBatchIndicator')
    if (vt25) { this.activeVT25 = vt25 } else { LocalStorage.remove('activeBatchIndicator') }
    this.selectedVT25 = this.activeVT25
    const res = await BatchRegistration.getCurrentWeightIds()
    if (!res.failed && res.data.length) {
      this.VT25List = res.data
    } else {
      // Simulation VT25 ids, if none found in service (no VT25 is sending Weight results yet)
      // simulateWeightFromWheelLoader: click on headline "Wheel loader weight input" in
      // Select active Wheel Loader via Wheel Loader button long press (contextmenu)
      // this.VT25List = ['VT25 #1', 'VT25 #2']
    }

    this.loadBatchesIntervalId = setInterval(async () => {
      // Re-Load agreements
      if (this.$route.params.id) {
        const res = await BatchRegistration.loadBatchOrder(this.$route.params.id)
        if (!res.failed) {
          this.item = res.data
          const bres = await BatchRegistration.loadAllBatchOrders(this.$route.params.id)
          if (!bres.failed) {
            this.batchregistrations = bres.data
          }
        }
      }
    }, 10000)
    // Start Timer with getWeight check to VT25 box (and communication to WK60)
    this.getLiveWeightTimer = setInterval(async () => {
      // Only check IsAlive, if last check has ended
      // this.enableVT25WeightIntegration &&
      if (this.activeVT25) {
        if (this.RegDelay !== 0) {
          this.RegDelay -= 2
        }
        this.checkkingIsAlive = true
        const res = await BatchRegistration.getWeight({ VT25Id: this.activeVT25, ResetWeight: 'False' })
        if (res.failed) {
          this.isAlive = false
          this.displayWeight = '�'
          this.firstErrorStatus = 'No connection'
          this.$root.$message.showError('GetWeight for "' + this.activeVT25 + '" errors')
        } else {
          if ((this.regWeight < res.data.WeightKg - 200 || this.regWeight > res.data.WeightKg + 200) && !this.minChanged) {
            this.minChanged = true
          }
          this.displayWeight = res.data.WeightKg.toString()
          this.firstErrorStatus = res.data.ErrorMsg
          if (res.data.IsStable) {
            this.item.WeightNet = res.data.WeightKg
            this.stable = true
          } else {
            this.item.WeightNet = res.data.WeightKg // + ' ~ '
            this.stable = false
          }
          if (!this.isAlive) this.isAlive = true
        }
        this.checkkingIsAlive = false
      }
    }, 2000)
  }
}
</script>

<style>
  p {
    font-size: 16px;
  }
</style>

<style scoped>
input[type='file'] {
  position: absolute;
  left: -99999px;
}
.image_container {
  position: relative;
  display: inline-block;
  text-align: center;
}
.image_container img {
  max-width: 100%;
}
.image_container .after {
  position: absolute;
  top: 0;
  left: 0;
}
.faded {
  opacity: 0.75;
}
</style>
